import { onError } from 'apollo-link-error';
import { ApolloLink } from '@apollo/client/core';
import { handleAuthenticationError } from '../../../util/sessionExpiry';

export const errorLink = () =>
  onError(({ response, networkError, graphQLErrors }) => {
    if (handleAuthenticationError({ networkError, graphQLErrors })) return;
    console.error(response);
  }) as unknown as ApolloLink;
